import { Mutation } from 'vuex-module-decorators';
import { InjectModule, InjectVuexModule } from 'vue-di/vuex';

@InjectModule({ stateFactory: true }, module)
export default class HeaderModule extends InjectVuexModule {
     public logo = '';

    @Mutation
    public setHeaderLogo(logo: string): void {
        this.logo = logo
    }

    get getHeaderLogo() {
        return this.logo
    }
}
